import axios from "axios"
import store from "../store"

axios.defaults.baseURL = process.env.VUE_APP_API_URL

axios.interceptors.request.use(async (request) => {

  if (!store.state.auth.fbUser)
    return request
  
  request.headers.common["auth-token"] = await store.state.auth.fbUser.getIdToken()

  return request

}, (error) => Promise.reject(error))

axios.interceptors.response.use((response) => response.data, (error) => {

  if (error.response && error.response.data && error.response.data.errorCode == 401) {    

    Promise.resolve()
    location.reload()    

  }  else {

    return Promise.reject(error)
  }  
})

export default axios